const obj = {
    apiTimeout: 15000, // 超时时间
    version: '3.31.0', // 版本
    channelId: 3000001,
};
// 合并环境参数与配置参数
export default {
    ...defaultConf.default,
    ...obj,
};
